import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeBomWire } from '#/api/momMgmt/settings/bom/normalizeBomWire';
import { buildBomWritePayload } from '#/api/momMgmt/settings/bom/serializeBomWrite';

export async function createBom(values) {
  const { data: raw } = await request.post(
    '/mom/bom',
    keysToSnake(buildBomWritePayload(values)),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeBomWire(parsed.data),
  };
}
